export const SET_RX = 'SET_RX';
export const UPDATE_USER_SHIPPING_INFO = 'UPDATE_USER_SHIPPING_INFO';
export const UPDATE_USER_PAYMENT_INFO = 'UPDATE_USER_PAYMENT_INFO';
export const UPDATE_USER_CVC = 'UPDATE_USER_CVC';
export const ERROR_SET_RX = 'ERROR_SET_RX';
export const UPDATE_DEFAULT_PAYMENT = 'UPDATE_DEFAULT_PAYMENT';
export const UPDATE_PAYMENT_OPTIONS = 'UPDATE_PAYMENT_OPTIONS';
export const SET_JWT = 'SET_JWT';
export const SET_RX_FORM_VALUES = 'SET_RX_FORM_VALUES';
export const UPDATE_TAX_DISPLAY = 'UPDATE_TAX_DISPLAY';
export const PRACTICE_PLATFORM_TYPE_VPA = 5;
export const PRACTICE_PLATFORM_TYPE_RR = 6;

export const INVALID_RX_TEMPLATE = phone =>
    `*We are not able to fill your prescription at this time. Please contact ${phone} to fill your order.`;
export const PRACTICE_TYPE_FLAG_RR = 'RR';
// export const PRACTICE_TYPE_FLAG_VPA = 'VPA';
export const INVALID_RX_RR_PHONE = '877-518-4589';
export const INVALID_RX_VPA_PHONE = '877-838-7979';
export const INVALID_RX_VFC_PHONE = '888-606-3336';
export const RX_NOT_FOUND_TEMPLATE =
  '*The name or prescription number you have entered does not match our records.  Please try again or contact <a href="/contact">Customer Service</a>.';

export const ORDER_CONF_EMAIL_SEND_SUCCESS = 'ORDER_CONF_EMAIL_SEND_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/userInformation/types.js